var map = {
	"./blue/new.png": "./src/assets/image/blue/new.png",
	"./purple/new.png": "./src/assets/image/purple/new.png",
	"./red/new.png": "./src/assets/image/red/new.png",
	"./yellow/new.png": "./src/assets/image/yellow/new.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\/new\\.png$";